import React from 'react';
import style from './HeroContainer.module.scss';

const HeroContainer = props => (
  <div
    className={`${style.heroContainer} ${props.top ? style.top : ''} ${
      props.exiting ? style.exiting : ''
    }`}
  >
    <div className={style.heroWrap}>{props.children}</div>
  </div>
);

export default HeroContainer;



// WEBPACK FOOTER //
// ./src/components/ui/HeroContainer.js